// Category constants for machine types.
// Two orderings exported for different contexts:
//   - CATEGORIES_BY_USAGE: HQ internal use, ordered by Agriware curation frequency
//   - CATEGORIES_ALPHABETICAL: Ops customer onboarding, alphabetical for discoverability

export const CATEGORIES = {
  agricultural: { code: 'agricultural', label: 'Agricultural' },
  plant:        { code: 'plant',        label: 'Plant' },
  groundcare:   { code: 'groundcare',   label: 'Groundcare' },
  atv:          { code: 'atv',          label: 'ATV' },
  vehicle:      { code: 'vehicle',      label: 'Vehicle' },
};

// HQ — ordered by usage frequency
export const CATEGORIES_BY_USAGE = [
  CATEGORIES.agricultural,
  CATEGORIES.plant,
  CATEGORIES.groundcare,
  CATEGORIES.atv,
  CATEGORIES.vehicle,
];

// Ops — alphabetical
export const CATEGORIES_ALPHABETICAL = Object.values(CATEGORIES)
  .sort((a, b) => a.label.localeCompare(b.label));

export const getCategoryLabel = (code) => CATEGORIES[code]?.label || code;
